export default "__VITE_ASSET__BDrvq505__"